import React from 'react';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { TopNav } from './components/TopNav/TopNav';

export enum Viewer {
  Advisor,
  Consumer,
  Print,
  EngagementWorkflow,
}

interface Props {
  variant?: Viewer;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children, variant } = this.props;

    if (hasError) {
      return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" height="100vh">
          {(variant === Viewer.Advisor || variant === Viewer.Consumer) && <TopNav />}

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100%"
            css={`
              background: ${({ theme }) => theme.background};
            `}
          >
            <Text mb="8" fontSize="h3" fontWeight={600} color="neutral.600">
              Oops!
            </Text>

            <Text mb="32" fontSize="h5" color="neutral.400">
              Sorry, something went wrong. Please try again later.
            </Text>

            {(variant === Viewer.Advisor ||
              variant === Viewer.Consumer ||
              variant === Viewer.EngagementWorkflow) && (
              <Button
                size="medium"
                onClick={() => {
                  document.location.href = '/';
                }}
              >
                Back to homepage
              </Button>
            )}
          </Box>
        </Box>
      );
    }

    return children;
  }
}
